export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_PRODUCTS':
      return { ...state, products: action.products };
    case 'GET_PRODUCTS_COUNT':
      return { ...state, count: action.count };
    case 'GET_PRODUCTS_SEARCH':
      return { ...state, searched: action.searched };
    case 'GET_PRODUCTS_CHECKBUY':
      return { ...state, productsCheckbuy: action.productsCheckbuy };
    default:
      return state;
  }
};
